import React from 'react';
import type { IExistingImageProps } from '.';
import images from '../images';

export const ExistingImage: React.FC<IExistingImageProps> = ({ image, ...rest }) => {
  return image && <img src={images[image]} alt={image} {...rest} />;
};
